import { render, staticRenderFns } from "./LawCounterPartyList.vue?vue&type=template&id=fe2fa0c2&"
import script from "./LawCounterPartyList.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartyList.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartyList.vue?vue&type=style&index=0&id=fe2fa0c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports